__webpack_require__.p = "/anikaportfolio/";